<template>
  <div class="error-cant-create alert -danger">
    <template slot="title">Ops!</template>

    <p v-if="!unprocessableEntity && !paymentRequired">
      Infelizmente aconteceu um erro ao tentar realizar sua consulta,
      por favor tente novamente ou contate nossa equipe.
    </p>
    <div v-if="unprocessableEntity">
      <p>
        Infelizmente tivemos problemas ao tentar realizar sua consulta:
      </p>
      <ul class="errors">
        <li v-for="error in errors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div v-if="paymentRequired">
      <p>Infelizmente você não tem saldo o suficiente para realizar sua consulta.</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ErrorsCantCreate',

  props: {
    unprocessableEntity: {
      required: false,
      default: false,
    },
    paymentRequired: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  computed: {
    errors() {
      if (!this.unprocessableEntity) {
        return [];
      }

      return Object.values(this.unprocessableEntity.errors !== undefined ? { error: this.unprocessableEntity } : this.unprocessableEntity)
        .reduce((errors, group) => {
          const groupErrors = [].concat(...Object.values(group.errors))
            .filter((error) => !errors.includes(error));

          return errors.concat(groupErrors);
        }, []);
    },
  },
};
</script>

<style lang="scss" scoped>
  .error-cant-create {
    @apply mb-4;

    .errors {
      @apply pl-6;
      @apply mt-2;
      @apply list-disc;
    }
  }
</style>
